module.exports = __webpack_public_path__ + "dc95b864b51e1551c77c1f1adb4c3601.woff";


//////////////////
// WEBPACK FOOTER
// ../apps/chide/products/smapply/static/themes/fonts/OpenSans-Semibold-webfont.woff
// module id = 2518
// module chunks = 17